import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { compose } from "redux";
import { selectors as sessionSelectors } from "reducers/session";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";
import Head from "pages/_components/Head";
import Logo from "pages/login/_components/Logo";
import { func, shape, bool } from "prop-types";
import GridLayoutExternal from "pages/_layouts/GridLayoutExternal";
import * as i18n from "util/i18n";
import I18n from "./I18n";

class SupportInfo extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        hasActiveSession: bool,
        history: shape({ goBack: func }),
        propsGrid: shape({}).isRequired,
        isMobile: bool,
        isDesktop: bool,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        hasActiveSession: false,
        history: null,
        isMobile: false,
        isDesktop: true,
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, hasActiveSession } = this.props;
        const { embeddedInV3Shell: prevEmbedded, isDesktop: prevDesktop, hasActiveSession: prevSession } = prevProps;
        if (prevEmbedded !== embeddedInV3Shell || prevDesktop !== isDesktop || prevSession !== hasActiveSession) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch, hasActiveSession } = this.props;
        if (!hasActiveSession) {
            return;
        }
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            titleKey: "global.support",
            goBackPath: "/v3/dashboard",
            scopes: ["support"],
        });
    };

    backButtonAction = () => {
        const { dispatch, hasActiveSession, history } = this.props;
        return hasActiveSession ? history.goBack() : dispatch(push("/"));
    };

    renderLogoMobile = () => <Logo className="svg-image logo logo-mobile-size" logoColor />;

    renderContent = () => {
        const { isMobile, embeddedInV3Shell } = this.props;

        return (
            <>
                <div>
                    {isMobile && !embeddedInV3Shell && (
                        <I18n
                            id="global.support"
                            accessibilityTextId="login.step4.termsAndCondiciones.label.a11yss"
                            component="h2"
                            componentProps={{ className: "modal-header text-center" }}
                        />
                    )}
                    <div className="border-top max-width-600 mx-auto px-3">
                        <I18n component="p" id="global.support.v3.intro" />
                        <p>
                            <I18n id="global.support.v3.whatsapp.label" />{" "}
                            <I18n id="global.support.v3.whatsapp.value" />
                        </p>
                        <p>
                            <I18n id="global.support.v3.email.label" />{" "}
                            <a href={i18n.get("global.support.v3.email.href")}>
                                <I18n id="global.support.v3.email.value" />
                            </a>
                        </p>
                        <p>
                            <I18n id="global.support.v3.phone.label" />{" "}
                            <a href={i18n.get("global.support.v3.phone.href")}>
                                <I18n id="global.support.v3.phone.value" />
                            </a>
                        </p>
                    </div>
                </div>
            </>
        );
    };

    render() {
        const { hasActiveSession, isMobile, propsGrid, embeddedInV3Shell, isDesktop } = this.props;

        return hasActiveSession ? (
            <>
                {!(embeddedInV3Shell && !isDesktop) && (
                    <div className="admin-detail-head px-0">
                        <Head onBack={this.backButtonAction} />
                        <Head title="global.support" titleClassName="mx-auto" />
                    </div>
                )}
                {this.renderContent()}
            </>
        ) : (
            <GridLayoutExternal isDesktop={!isMobile} {...propsGrid} showLogoState>
                <Head
                    onClose={this.backButtonAction}
                    title={!isMobile && "global.support"}
                    headerClassName={isMobile ? "login-background-color-white" : "recover-pass-desktop h-auto mb-2"}
                    centerElement={isMobile && this.renderLogoMobile}
                    fixed
                />
                {this.renderContent()}
            </GridLayoutExternal>
        );
    }
}

const mapStateToProps = (state) => ({
    hasActiveSession: sessionSelectors.isLoggedIn(state),
});

export default withRouter(compose(connect(mapStateToProps), resizableRoute)(SupportInfo));
